import { render, staticRenderFns } from "./alerthistoryitem.vue?vue&type=template&id=44ed2374&scoped=true&"
import script from "./alerthistoryitem.vue?vue&type=script&lang=js&"
export * from "./alerthistoryitem.vue?vue&type=script&lang=js&"
import style0 from "./alerthistoryitem.vue?vue&type=style&index=0&id=44ed2374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed2374",
  null
  
)

export default component.exports